import { OverlayRef } from '@angular/cdk/overlay';

export class SelectedItemsVisualizerOverlayRef {
  constructor(private overlayRef: OverlayRef) { }

  close(): void {
    this.overlayRef.dispose();
  }
}
